// Rendu partagé d'un champ "richtext" (titre/sous-titre/paragraphe édité
// via RichTextEditor.jsx, voir frontend/src/pages/admin/ThemeEditor/) — le
// contenu est déjà assaini côté serveur avant sauvegarde (voir
// theme_service._sanitize_richtext), jamais re-nettoyé ici. Vit dans
// components/ (pas themes/default/) : c'est un simple utilitaire de rendu,
// sans aucune logique propre au moteur de thème "default" — Footer.jsx/
// Header.jsx (chrome partagé entre moteurs, jamais dupliqué par moteur) en
// ont besoin au même titre que les sections de themes/default/sections/.
//
// Tiptap enveloppe TOUJOURS son contenu dans un <p> (même pour un champ
// mono-ligne comme un titre de carte) — par défaut, le reset
// `[&_p]:m-0 [&_p]:inline` neutralise la marge/le display bloc de ce <p>
// pour qu'il ne produise aucun espacement parasite une fois déposé dans une
// balise de titre (<h3>, etc.), sans avoir à manipuler les balises côté
// serveur pour cette seule raison cosmétique.
//
// `preserveParagraphs` (à passer pour "body", le seul type de champ
// richtext pensé pour du texte VRAIMENT multi-paragraphe) désactive ce
// reset : un admin qui appuie sur Entrée doit alors obtenir de vrais
// paragraphes espacés, pas du texte fondu en un seul bloc.
export default function RichText({ html, as: Tag = "span", className = "", preserveParagraphs = false, ...rest }) {
  if (!html) return null;
  const reset = preserveParagraphs ? "" : "[&_p]:m-0 [&_p]:inline";
  return <Tag className={`${reset} ${className}`} dangerouslySetInnerHTML={{ __html: html }} {...rest} />;
}

// Un champ "richtext" réutilisé là où seul du texte brut est possible (un
// attribut HTML — `title`, `alt`, `aria-label` — ou un <title> de document
// via useSeo) ne peut jamais contenir de balises : les navigateurs les
// afficheraient littéralement plutôt que de les interpréter. À utiliser
// PARTOUT où un champ promu "richtext" (voir richTextVariants.js) était
// auparavant réinjecté tel quel dans un attribut/titre de page.
export function stripHtml(html) {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "");
}
